module.exports = __webpack_public_path__ + "img/JUIZ DE FORA - SETCJF.e85d4055.png";